var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoubleArrow = function SvgDoubleArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76489 10.7648L6.26489 6.26483C6.4102 6.11952 6.4102 5.88046 6.26489 5.73514L1.76489 1.23514C1.61958 1.08983 1.38052 1.08983 1.23521 1.23514C1.08989 1.38046 1.08989 1.61952 1.23521 1.76483L5.47036 5.99999L1.23521 10.2351C1.08989 10.3805 1.08989 10.6195 1.23521 10.7648C1.38052 10.9101 1.61958 10.9101 1.76489 10.7648ZM6.26489 10.7648L10.7649 6.26483C10.9102 6.11952 10.9102 5.88046 10.7649 5.73514L6.26489 1.23514C6.11958 1.08983 5.88052 1.08983 5.7352 1.23514C5.58989 1.38046 5.58989 1.61952 5.7352 1.76483L9.97036 5.99999L5.7352 10.2351C5.58989 10.3805 5.58989 10.6195 5.7352 10.7648C5.88052 10.9101 6.11958 10.9101 6.26489 10.7648Z"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doubleArrow.7f85289c.svg";
export { ForwardRef as ReactComponent };